import {FormatMessageFunction, ObjectOfAny} from '../../../../types';
import getRequiredFieldErrorMessageFromName from './getRequiredErrorMessageFromName';
import {FieldErrorMessage} from '../types';

const getRequiredMessage = (
  formatMessage: FormatMessageFunction,
  // @todo: remove legacy validation - useCustom will be removable
  useCustom: boolean,
  // @todo: remove legacy validation - name will not be required as a param
  name: string | number | symbol,
  value: string | boolean | File[],
  required: boolean,
  requiredMessage?: FieldErrorMessage,
  messageValues: ObjectOfAny = {}
): string | undefined => {
  if (
    required &&
    (((typeof value === 'string' || Array.isArray(value)) && !value.length) || value === false || value === undefined)
  ) {
    const defaultMessage = formatMessage({id: 'apply.errors.generic.empty'});
    if (useCustom) {
      return typeof requiredMessage === 'function' ? requiredMessage(messageValues) : requiredMessage || defaultMessage;
    }
    // @todo: remove legacy validation
    return getRequiredFieldErrorMessageFromName(String(name), formatMessage);
  }

  return undefined;
};

export default getRequiredMessage;
